module.exports = __webpack_public_path__ + "img/json.62897861.svg";